module.exports = __webpack_public_path__ + "static/media/74.a68fa2e1.png";